// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/payment-method-sprites.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
.SuccessPayment_componentWrapper__IQOeT {
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);
  border: 1px solid #ced4da;
  padding: 30px;
  background-color: #F5F5F5;
}

.SuccessPayment_successBlock__a9NJB {
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  color: #666;
}

.SuccessPayment_bgGreen__Nfwj5 {
  color: #73c573;
  padding: 10px 20px;
  border-radius: 6px;
  display: inline-block;
  font-size: 48px !important;
  font-weight: 300;
}

.SuccessPayment_successIcon__9QArV {
  width: 160px;
  height: 160px;
  margin: 20px auto;
  display: block;
}

.SuccessPayment_sectionTitle__e44rK {
  font-size: 34px;
  margin-bottom: 10px;
  color: #666;
  font-weight: 600;
}

.SuccessPayment_sectionSubtitle__qzSqg {
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 300;
  color: #666666;
}
.SuccessPayment_sectionSubtitle__qzSqg .SuccessPayment_font-italic__0YLZY {
  font-style: italic !important;
}
.SuccessPayment_sectionSubtitle__qzSqg .SuccessPayment_font-italic__0YLZY .SuccessPayment_gfw-7__I8WvK {
  font-weight: 700 !important;
}

.SuccessPayment_enrolled__vQZDL {
  font-size: 20px;
  margin-bottom: 25px;
  color: #000000;
  text-align: center;
}

.SuccessPayment_planSummary__RnUCt {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
}

.SuccessPayment_planName__qU25T {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #222;
}

.SuccessPayment_paymentMethod__UHjcH {
  font-size: 16px;
  color: #444;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.SuccessPayment_cardImg__DliLn {
  width: 50px;
  height: auto;
}

.SuccessPayment_row__d8OCL {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}

.SuccessPayment_btn__LZD\\+M {
  border: none;
  padding: 12px 30px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  border-radius: 0;
  min-width: 160px;
  color: #ffffff;
  line-height: 1.3;
  font-weight: 400;
  transition: background-color 0.3s ease;
}
.SuccessPayment_btn__LZD\\+M:hover {
  transform: translateY(-1px);
  text-decoration: underline !important;
}

.SuccessPayment_btnGray__ZVeXw {
  background-color: #9e9e9e;
  color: #fff;
}
.SuccessPayment_btnGray__ZVeXw:hover {
  background-color: #858585;
}

.SuccessPayment_btnOrange__sB1\\+6 {
  background-color: #ffa61b;
  color: #fff;
}

.SuccessPayment_btnLarge__-sXME {
  font-size: 26px;
  padding: 13px 26px;
}

.SuccessPayment_printBtn__T6oDQ {
  margin-left: 10px;
}

.SuccessPayment_planList__Dc8\\+8 {
  margin-top: 20px;
}

.SuccessPayment_planSummary__RnUCt {
  background-color: #fafafa;
  border: 1px solid #000000;
  border-radius: 0px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0;
}

.SuccessPayment_planRow__Nzuq1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.SuccessPayment_planName__qU25T {
  flex: 1 1;
  font-size: 30px;
  font-weight: 300;
  color: #4b4848;
}

.SuccessPayment_paymentMethod__UHjcH {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: #444;
  flex: 1 1;
  justify-content: flex-end;
}
.SuccessPayment_paymentMethod__UHjcH b {
  font-size: 20px;
  font-weight: 350;
  color: #4b4848;
}
.SuccessPayment_paymentMethod__UHjcH strong {
  font-size: 20px;
  font-weight: 350;
  color: #4b4848;
}

.SuccessPayment_cardImg__DliLn {
  width: 72px;
  height: auto;
}

.SuccessPayment_lastDigits__iwKF0 {
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .SuccessPayment_componentWrapper__IQOeT {
    background-color: #ffffff;
    border: 0;
    box-shadow: none;
    padding: 0;
  }
  .SuccessPayment_componentWrapper__IQOeT .SuccessPayment_bgGreen__Nfwj5 {
    font-size: 36px;
  }
  .SuccessPayment_componentWrapper__IQOeT .SuccessPayment_sectionSubtitle__qzSqg {
    font-size: 16px;
  }
  .SuccessPayment_componentWrapper__IQOeT .SuccessPayment_enrolled__vQZDL {
    line-height: 1.2;
    margin-bottom: 10px;
  }
  .SuccessPayment_componentWrapper__IQOeT .SuccessPayment_btn__LZD\\+M {
    min-width: 146px !important;
    display: inline-block !important;
    margin-top: 20px;
    padding: 5px 26px;
  }
}
.SuccessPayment_mma--payment-method__pwUUG {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: auto 45px;
  height: 45px;
  margin: 0 auto;
  width: 72px;
}
.SuccessPayment_mma--payment-method__pwUUG.AmericanExpress {
  background-position: 0 0;
}
.SuccessPayment_mma--payment-method__pwUUG.Visa {
  background-position: -218px 0;
}
.SuccessPayment_mma--payment-method__pwUUG.Mastercard {
  background-position: -144px 0;
}
.SuccessPayment_mma--payment-method__pwUUG.DiscoverCard {
  background-position: -72px 0;
}
.SuccessPayment_mma--payment-method__pwUUG.Checking {
  background-position: -360px 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/SuccessPayment.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAZA;EACI,gDAAA;EACA,yBAAA;EACA,aAAA;EACA,yBC6FO;AD/EX;;AAVA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAaJ;;AATA;EAEI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;AAWJ;;AARA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAWJ;;AARA;EACI,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAWJ;;AARA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCiBW;ADNf;AATI;EACI,6BAAA;AAWR;AATQ;EACI,2BAAA;AAWZ;;AANA;EACI,eAAA;EACA,mBAAA;EACA,cCZI;EDaJ,kBAAA;AASJ;;AANA;EACI,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AASJ;;AANA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AASJ;;AANA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AASJ;;AANA;EACI,WAAA;EACA,YAAA;AASJ;;AANA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AASJ;;AALA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cC9DI;ED+DJ,gBAAA;EACA,gBCqBC;EDpBD,sCAAA;AAQJ;AANI;EAEI,2BAAA;EACA,qCAAA;AAOR;;AAAA;EACI,yBC5DK;ED6DL,WAAA;AAGJ;AADI;EACI,yBC/DC;ADkET;;AAIA;EACI,yBAAA;EACA,WAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AADJ;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AADJ;;AAIA;EAEI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AAFJ;AAII;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAFR;AAKI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAHR;;AAOA;EACI,WAAA;EACA,YAAA;AAJJ;;AAOA;EACI,eAAA;EACA,WAAA;AAJJ;;AAOA;EACI;IACI,yBCtKA;IDuKA,SAAA;IACA,gBAAA;IACA,UAAA;EAJN;EAMM;IACI,eAAA;EAJV;EAOM;IACI,eAAA;EALV;EAQM;IACI,gBAAA;IACA,mBAAA;EANV;EASM;IACI,2BAAA;IACA,gCAAA;IACA,gBAAA;IACA,iBAAA;EAPV;AACF;AAWA;EACI,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AATJ;AAYI;EACI,wBAAA;AAVR;AAaI;EACI,6BAAA;AAXR;AAcI;EACI,6BAAA;AAZR;AAeI;EACI,4BAAA;AAbR;AAgBI;EACI,6BAAA;AAdR","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use 'abstracts/variables' as *;\n\n.componentWrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);\n    border: 1px solid $border-grey; // light gray border\n    padding: 30px;\n    background-color: $bg-white1; // optional for contrast\n}\n\n\n.successBlock {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 20px;\n    color: #666;\n\n}\n\n.bgGreen {\n\n    color: #73c573;\n    padding: 10px 20px;\n    border-radius: 6px;\n    display: inline-block;\n    font-size: 48px !important;\n    font-weight: 300;\n}\n\n.successIcon {\n    width: 160px;\n    height: 160px;\n    margin: 20px auto;\n    display: block;\n}\n\n.sectionTitle {\n    font-size: 34px;\n    margin-bottom: 10px;\n    color: #666;\n    font-weight: 600;\n}\n\n.sectionSubtitle {\n    margin-bottom: 10px;\n    font-size: 28px;\n    font-weight: 300;\n    color: $light-gray2;\n\n    .font-italic {\n        font-style: italic !important;\n\n        .gfw-7 {\n            font-weight: $fw7 !important;\n        }\n    }\n}\n\n.enrolled {\n    font-size: 20px;\n    margin-bottom: 25px;\n    color: $black;\n    text-align: center;\n}\n\n.planSummary {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    padding: 20px;\n    margin-bottom: 20px;\n    border-radius: 6px;\n}\n\n.planName {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: #222;\n}\n\n.paymentMethod {\n    font-size: 16px;\n    color: #444;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.cardImg {\n    width: 50px;\n    height: auto;\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 30px;\n\n}\n\n.btn {\n    border: none;\n    padding: 12px 30px;\n    font-size: 18px;\n    cursor: pointer;\n    text-align: center;\n    text-decoration: none;\n    border-radius: 0;\n    min-width: 160px;\n    color: $white;\n    line-height: 1.3;\n    font-weight: $fw4;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n\n        transform: translateY(-1px);\n        text-decoration: underline !important;\n    }\n\n}\n\n\n\n.btnGray {\n    background-color: $grey5;\n    color: #fff;\n\n    &:hover {\n        background-color: $grey6; // darker gray\n\n    }\n\n\n}\n\n.btnOrange {\n    background-color: #ffa61b;\n    color: #fff;\n}\n\n.btnLarge {\n    font-size: 26px;\n    padding: 13px 26px;\n}\n\n.printBtn {\n    margin-left: 10px;\n}\n\n.planList {\n    margin-top: 20px;\n}\n\n.planSummary {\n    background-color: #fafafa;\n    border: 1px solid $black;\n    border-radius: 0px;\n    padding: 20px;\n    margin-bottom: 20px;\n    box-shadow: 0;\n}\n\n.planRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.planName {\n\n    flex: 1;\n    font-size: 30px;\n    font-weight: 300;\n    color: #4b4848;\n}\n\n.paymentMethod {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    font-size: 18px;\n    color: #444;\n    flex: 1;\n    justify-content: flex-end;\n\n    b {\n        font-size: 20px;\n        font-weight: 350;\n        color: #4b4848;\n    }\n\n    strong {\n        font-size: 20px;\n        font-weight: 350;\n        color: #4b4848;\n    }\n}\n\n.cardImg {\n    width: 72px;\n    height: auto;\n}\n\n.lastDigits {\n    font-size: 14px;\n    color: #666;\n}\n\n@media (max-width: 768px) {\n    .componentWrapper {\n        background-color: $white;\n        border: 0;\n        box-shadow: none;\n        padding: 0;\n\n        .bgGreen {\n            font-size: 36px;\n        }\n\n        .sectionSubtitle {\n            font-size: 16px;\n        }\n\n        .enrolled {\n            line-height: 1.2;\n            margin-bottom: 10px;\n        }\n\n        .btn {\n            min-width: 146px !important;\n            display: inline-block !important;\n            margin-top: 20px;\n            padding: 5px 26px;\n        }\n    }\n}\n\n.mma--payment-method {\n    background-image: url(../../public/images/payment-method-sprites.png);\n    background-repeat: no-repeat;\n    background-size: auto 45px;\n    height: 45px;\n    margin: 0 auto;\n    width: 72px;\n\n    // Card type specific positioning for sprite\n    &:global(.AmericanExpress) {\n        background-position: 0 0;\n    }\n\n    &:global(.Visa) {\n        background-position: -218px 0;\n    }\n\n    &:global(.Mastercard) {\n        background-position: -144px 0;\n    }\n\n    &:global(.DiscoverCard) {\n        background-position: -72px 0;\n    }\n\n    &:global(.Checking) {\n        background-position: -360px 0;\n    }\n}","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentWrapper": `SuccessPayment_componentWrapper__IQOeT`,
	"successBlock": `SuccessPayment_successBlock__a9NJB`,
	"bgGreen": `SuccessPayment_bgGreen__Nfwj5`,
	"successIcon": `SuccessPayment_successIcon__9QArV`,
	"sectionTitle": `SuccessPayment_sectionTitle__e44rK`,
	"sectionSubtitle": `SuccessPayment_sectionSubtitle__qzSqg`,
	"font-italic": `SuccessPayment_font-italic__0YLZY`,
	"gfw-7": `SuccessPayment_gfw-7__I8WvK`,
	"enrolled": `SuccessPayment_enrolled__vQZDL`,
	"planSummary": `SuccessPayment_planSummary__RnUCt`,
	"planName": `SuccessPayment_planName__qU25T`,
	"paymentMethod": `SuccessPayment_paymentMethod__UHjcH`,
	"cardImg": `SuccessPayment_cardImg__DliLn`,
	"row": `SuccessPayment_row__d8OCL`,
	"btn": `SuccessPayment_btn__LZD+M`,
	"btnGray": `SuccessPayment_btnGray__ZVeXw`,
	"btnOrange": `SuccessPayment_btnOrange__sB1+6`,
	"btnLarge": `SuccessPayment_btnLarge__-sXME`,
	"printBtn": `SuccessPayment_printBtn__T6oDQ`,
	"planList": `SuccessPayment_planList__Dc8+8`,
	"planRow": `SuccessPayment_planRow__Nzuq1`,
	"lastDigits": `SuccessPayment_lastDigits__iwKF0`,
	"mma--payment-method": `SuccessPayment_mma--payment-method__pwUUG`
};
export default ___CSS_LOADER_EXPORT___;
